"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-CollectionList',
    loading: 'c-CollectionList--loading'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        padding: theme_1.DefaultTheme.space(1)
    },
    _a[exports.CSS.loading] = {
        display: 'flex',
        'justify-content': 'center'
    },
    _a);
//# sourceMappingURL=collection.list.style.js.map